import { Autocomplete } from "@visioni/a3s-ui/components";
import type { IncidentSummaryPeriod } from "@visioni/a3s-monitoring/app";

interface PeriodOption {
  /** As the URL carries it; `undefined` for the default, day, which writes no param. */
  readonly period: Exclude<IncidentSummaryPeriod, "day"> | undefined;
  readonly label: string;
}

const OPTIONS: readonly PeriodOption[] = [
  { period: undefined, label: "By day" },
  { period: "week", label: "By week (from Monday)" },
  { period: "month", label: "By month" },
];

const optionId = (o: PeriodOption) => o.period ?? "day";
const optionLabel = (o: PeriodOption) => o.label;

/** What the totals are broken down into, in the list's timezone. */
export function PeriodField({
  value,
  onChange,
}: {
  readonly value: string | undefined;
  readonly onChange: (period: "week" | "month" | undefined) => void;
}) {
  const selected = OPTIONS.find((o) => o.period === value) ?? OPTIONS[0] ?? null;
  return (
    <Autocomplete<PeriodOption>
      options={OPTIONS}
      value={selected}
      onChange={(option) => onChange(option?.period)}
      getOptionLabel={optionLabel}
      getOptionId={optionId}
      placeholder="By day"
      label="Totals"
      floatLabel="always"
    />
  );
}
